import React from "react";
import useInspection from "../../../hooks/inspections/useInspection";
import { InspectionStatuses } from "../citizen-inspection-list/constants/InspectionStatus";
import StaffCompletedInspectionSummary from "./StaffCompletedInspectionSummary";
import StaffPreviousInspectionSummary from "./StaffPreviousInspectionSummary";

export interface StaffInspectionSummaryProps {
  id: string | number;
}
export default function StaffInspectionSummary({ id }: StaffInspectionSummaryProps) {
  const { inspectionQuery } = useInspection({ id });
  const status = inspectionQuery.data?.data.attributes.status;

  const completed = status === InspectionStatuses.FAILED || status === InspectionStatuses.PASSED;
  if (completed) {
    return <StaffCompletedInspectionSummary id={id} />;
  }
  return <StaffPreviousInspectionSummary id={id} />;
}
